/**
 * Client Mapping service for managing buyer groups and their client associations
 */

import { apiClient } from './apiClient';

/**
 * Get all Client Mappings
 */
export const getWRTBuyers = async () => {
  try {
    const response = await apiClient.get(`/api/v1/wrt-buyers`);
    return response.data.data || [];
  } catch (error) {
    console.error('Failed to fetch Client Mappings:', error);
    return [];
  }
};

/**
 * Get single Client Mapping by ID
 */
export const getWRTBuyerById = async (id) => {
  try {
    const response = await apiClient.get(`/api/v1/wrt-buyers/${id}`);
    return response.data.data || null;
  } catch (error) {
    console.error('Failed to fetch Client Mapping:', error);
    return null;
  }
};

/**
 * Create Client Mapping
 */
export const createWRTBuyer = async (buyerData) => {
  try {
    const response = await apiClient.post(`/api/v1/wrt-buyers/add`, {
      buyerName: buyerData.buyerName,
      clientIds: buyerData.clientIds,
    });
    return response.data.data;
  } catch (error) {
    console.error('Failed to create Client Mapping:', error);
    throw error;
  }
};

/**
 * Update Client Mapping
 */
export const updateWRTBuyer = async (id, buyerData) => {
  try {
    const response = await apiClient.patch(`/api/v1/wrt-buyers/${id}`, {
      buyerName: buyerData.buyerName,
      clientIds: buyerData.clientIds,
    });
    return response.data.data;
  } catch (error) {
    console.error('Failed to update Client Mapping:', error);
    throw error;
  }
};

/**
 * Delete Client Mapping
 */
export const deleteWRTBuyer = async (id) => {
  try {
    await apiClient.delete(`/api/v1/wrt-buyers/${id}`);
    return true;
  } catch (error) {
    console.error('Failed to delete Client Mapping:', error);
    throw error;
  }
};
